import React, { useEffect, useState } from "react";
import { FormGroup } from "components/common";
import { Table} from "reactstrap";
import { Control, LocalForm } from "react-redux-form";
import Select from "react-select";
import { Edit } from "./Edit";
import { NotificationManager } from "react-notifications";
import ColumnsList from "../Columns/List";
import StagesList from "../Stages/List";
import { useBaseModal } from "services";

const getStagesOptions = (stageFields) => {
  return stageFields.map((stage) => ({
      label: stage?.name,
      value: stage?.id,
  }));
};

const List = ({
  t,
  stageRows,
  getOptions,
  options,
  client,
  list_id,
  getListStageRows,
  filteredStageRows,
  setFilteredStageRows,
}) => {
  const [listColumns, setListColumns] = useState([]);
  const [selectedStageId, setSelectedStageId] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  
  const [SetUpdateItemModal, UpdateItemToggle, UpdateItemModal] = useBaseModal();


  useEffect(() => {
    getListColumns();
  }, []);


  const getListColumns = async () => {
    const columns = await client.get(`list-details/${list_id}/tracking-list-column`).get("data");
    setListColumns(columns);
    return columns;
  };

  const changeRowStage = async(stage_id, row_id) => {
    const updatedPayload = {
      stage_id: stage_id,
      row_id: row_id
    };

    await client.put(`list-details/${list_id}/list-column-values/${row_id}/move_list_to_stage`, updatedPayload)
      .then((data) => {
        NotificationManager.success(t("List moved to stage successfully"));
        getListStageRows();
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.error) {
          NotificationManager.error(error.response.data.error);
        } else {
          NotificationManager.error("Something went wrong");
        };
      })
  };

  const handleCreateUpdateStageRowSubmit = async (values) => {
    let method = "post";
    let url = `list-details/${list_id}/list-column-values`;
    let transformedPayload = values;
    const transformedArray = Object.entries(values).map(([column, columnData]) => ({
      column: parseInt(column), 
      ...Object.keys(columnData).reduce((acc, key) => {
        acc[key] = isFinite(columnData[key]) ? Number(columnData[key]) : columnData[key];
        return acc;
      }, {}),
    }));

    if (selectedRowId) {
      method = "put";
      url = `${url}/${selectedRowId}`;
      transformedPayload = {
        list_item_values: [],
        stage_id: selectedStageId,
        row_id: selectedRowId
      };
      transformedPayload.list_item_values = transformedArray;
    } else {
      transformedPayload = {
        list_item_values: [],
        stage_id: selectedStageId
      };

      transformedPayload.list_item_values = transformedArray;
    }
    try {
      await client[method](url, transformedPayload);
      NotificationManager.success(t(`Item ${selectedRowId ? "updated" : "created"} successfully`));
      getListStageRows();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        NotificationManager.error(error.response.data.error);
      } else {
        NotificationManager.error("Something went wrong");
      };
    };
    UpdateItemToggle();
  };

  const rowValues = (colValue, col) => {
    const choice = col?.column_choices && col?.column_choices?.find((choice) => choice?.id === parseInt(colValue));
    if (col?.type === "yes_no") {
      if (colValue === 1) {
        colValue = "Yes";
      } else {
        colValue = "No";
      };
    };
    return choice ? choice?.name : colValue;
  };

  const handleUpdateRowToggleModal = (stage_id, row_id) => {
    setSelectedStageId(stage_id);
    setSelectedRowId(row_id);
    UpdateItemToggle(true);
  };

  const finalStageRows = filteredStageRows?.length > 0 ? filteredStageRows : stageRows;

  return (
    <>
      <div className=" mt-2 overflow-x auto-scroll">
        <Table className="border" size="sm" borderless>
          <thead className="bg-light">
            <tr className="bg-white">
              <th className="bg-white"></th>
              <ColumnsList setFilteredStageRows={setFilteredStageRows} client={client} list_id={list_id} stageRows={stageRows} t={t} options={options} listColumns={listColumns} getListColumns={getListColumns}/>
            </tr>
          </thead>
          <tbody>
            {finalStageRows.map((stage, index) => (
              <React.Fragment key={stage?.id}>
                <StagesList
                  stage={stage}
                  setSelectedRowId={setSelectedRowId}
                  setSelectedStageId={setSelectedStageId}
                  UpdateItemToggle={UpdateItemToggle}
                  t={t}
                  index={index}
                />

                {stage?.list_stage_rows?.length > 0 && (
                  stage?.list_stage_rows?.map((row, rowIndex) => (
                    <tr key={`row-${stage?.id}-${rowIndex}`} className={index % 2 === 0 ? "bg-light" : "bg-white"}>
                      <td className="text-left" style={{ width: "175px", zIndex: 999 }}>
                        <div className="row d-flex justify-content-start align-items-center">
                          <div className="col" md="12">
                            <LocalForm>
                              <FormGroup addControlClass={false} className="mt-2">
                                <Control.text
                                  model=".name"
                                  component={Select}
                                  simpleValue
                                  onChange={(selectedOption) => {
                                    changeRowStage(selectedOption, row?.id);
                                  }}
                                  options={getStagesOptions(stageRows)}
                                  value={{ label: stage?.name, value: stage?.id }}
                                  scrollMenuIntoView={false}
                                />
                              </FormGroup>
                            </LocalForm>
                          </div>
                        </div>
                      </td>
                      {listColumns?.map((column, colIndex) => (
                        <td key={`cell-${stage?.id}-${rowIndex}-${colIndex}`} className="text-left clickable" onClick={() => handleUpdateRowToggleModal(stage?.id, row?.id)}>
                          {rowValues(row?.cell_mapping?.[column?.id]?.column_value, column)}
                        </td>
                      ))}
                      <td></td>
                    </tr>
                  ))
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </div>

      <Edit
        t={t}
        UpdateItemModal={UpdateItemModal}
        SetUpdateItemModal={SetUpdateItemModal}
        handleCreateUpdateStageRowSubmit={handleCreateUpdateStageRowSubmit}
        listColumns={listColumns}
        getOptions={getOptions}
        stageRows={stageRows}
        selectedRowId={selectedRowId}
        selectedStageId={selectedStageId}
      />

    </>
  );
};

export default List;
